

import { Button, Card, Checkbox, Col, Form, Row } from 'antd';
import Footer from '../../../../components/common/Footer';
import PageHeading from "../../../../components/common/PageHeading";
import RightBar from '../../../../components/common/RightBar';
import FormAction from '../../../../components/common/FormAction';
import './WorkOrder.css'
const options = [
    { label: 'Option 1', value: 'option1' },
    { label: 'Option 2', value: 'option2' },
    { label: 'Option 3', value: 'option3' },
];
const AccountingPeriodsRightBar = [];

const WorkOrderSettings = () => {
    return (<>
        <div className="page-container">
            <div className="main-container">

                <PageHeading heading="Work Order Settings" />
                <Card
                    className='card-bg'
                    style={{
                        boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.1)'

                    }} title="General Settings">
                    <Row style={{ display: 'flex', margin: '15px 0px' }}>
                        <Col span={8}
                            style={{
                                display: 'flex', justifyContent: 'end', color: 'gray'
                            }}
                        >Complete Work Order</Col>
                        <Col span={1} style={{
                            display: 'flex',
                            justifyContent: 'center'
                        }}>
                            <Checkbox />

                        </Col>
                        <Col span={15}
                            style={{
                                display: 'flex',
                                justifyContent: 'start'
                            }}
                        >Mark work order as completed when associated with a bill</Col>
                    </Row>

                    <Row style={{ display: 'flex', margin: '15px 0px' }}>
                        <Col span={8}
                            style={{
                                display: 'flex', justifyContent: 'end', color: 'gray'
                            }}
                        >Show Limits</Col>
                        <Col span={1} style={{
                            display: 'flex',
                            justifyContent: 'center'
                        }}>
                            <Checkbox />

                        </Col>
                        <Col span={15}
                            style={{
                                display: 'flex',
                                justifyContent: 'start'
                            }}
                        >Show maintenance limit on printed, emailed, and texted work orders</Col>
                    </Row>
                    <Row style={{ display: 'flex', margin: '15px 0px' }}>
                        <Col span={8}
                            style={{
                                display: 'flex', justifyContent: 'end', color: 'gray'
                            }}
                        >Vendor Portal Link</Col>
                        <Col span={1} style={{
                            display: 'flex',
                            justifyContent: 'center'
                        }}>
                            <Checkbox />

                        </Col>
                        <Col span={15}
                            style={{
                                display: 'flex',
                                justifyContent: 'start'
                            }}
                        >Email vendors a secure Vendor Portal link to view work orders by default</Col>
                    </Row>
                    <Row style={{ display: 'flex', margin: '15px 0px' }}>
                        <Col span={8}
                            style={{
                                display: 'flex', justifyContent: 'end', color: 'gray'
                            }}
                        >Use Follow-up date</Col>
                        <Col span={1} style={{
                            display: 'flex',
                            justifyContent: 'center'
                        }}>
                            <Checkbox />

                        </Col>
                        <Col span={15}
                            style={{
                                display: 'flex',
                                justifyContent: 'start'
                            }}
                        ></Col>
                    </Row>
                    <Row style={{ display: 'flex', margin: '15px 0px' }}>
                        <Col span={8}
                            style={{
                                display: 'flex', justifyContent: 'end', color: 'gray'
                            }}
                        >My Work Orders Page</Col>
                        <Col span={16} style={{
                            display: 'flex',
                            justifyContent: 'start'
                        }}>
                            {/* <Checkbox /> */}
                            <a style={{ marginLeft: '12px' }}>Customize</a>
                        </Col>

                    </Row>


                </Card>


                <div style={{ margin: '10px 0px' }}>
                    <FormAction />
                </div>
                <Footer />
            </div>
        </div>
        <div className="RightSidebar">
            <RightBar RightBarData={AccountingPeriodsRightBar} />
        </div>
    </>

    )
}

export default WorkOrderSettings;
